<app-mobile-filters-modal (closeModal)="closeModal()">
  <app-catalog-sider
    [attributes]="(repository.attributes$ | async) || []"
    [isDesktop]="false"
  ></app-catalog-sider>
</app-mobile-filters-modal>
